"use client";

import { useEffect } from "react";
import i18next, { i18n } from "i18next";
import { initReactI18next, useTranslation as useTransAlias } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";

import { useLocale } from "../../context/LocaleContext";

import {
  Locales,
  getOptions,
  supportedLocales,
} from "./settings";

const runsOnServerSide = typeof window === "undefined";
const i18nextService = i18next
  .use(initReactI18next)
  .use(resourcesToBackend((lang: string, ns: string) => import(`../../public/locales/${lang}/${ns}.json`)));

const useTranslation = (ns: string | string[]) => {
  const lng = useLocale();
  if (!i18nextService.isInitialized) {
    i18nextService.init({
      ...getOptions(lng),
      preload: runsOnServerSide ? supportedLocales : [],
    });
  }

  const translator = useTransAlias(ns);
  const { i18n } = translator;

  // Run content is being rendered on server side
  if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
    i18n.changeLanguage(lng);
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useCustomTranslationImplem(i18n, lng);
  }
  return translator;
};

const useCustomTranslationImplem = (i18n: i18n, lng: Locales) => {
  useEffect(() => {
    if (!lng || i18n.resolvedLanguage === lng) return;
    i18n.changeLanguage(lng);
  }, [lng, i18n]);
};

export default useTranslation;
